<template>
  <div
    class="modal fade"
    id="checkPaymentModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>{{ lang.CPM000 }}</b>
          </h4>
        </div>
        <div class="modal-body" @change="paymentFormDirty = true">
          <div
            class="panel-group"
            id="accordionCheckPayment"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-default">
              <!-- Accordion entry 1 -->
              <div
                class="panel-heading"
                role="button"
                id="headingCheckPaymentGeneral"
                data-toggle="collapse"
                data-parent="#accordionCheckPayment"
                href="#collapseCheckPaymentGeneral"
                aria-expanded="true"
                aria-controls="collapseCheckPaymentGeneral"
              >
                <h4 class="panel-title">
                  <a class="collapsed"
                    >{{ lang.CPM001 }} ({{ checkDataList.length }})</a
                  >
                </h4>
              </div>
              <div
                id="collapseCheckPaymentGeneral"
                class="panel-collapse collapse in"
                role="tabpanel"
                aria-labelledby="headingCheckPaymentGeneral"
              >
                <div class="panel-body">
                  <div class="col-md-12 text-red text-bold">
                    {{ lang.CPM002 }}
                  </div>

                  <div class="col-xs-12">
                    <button
                      class="btn btn-raised"
                      @click.prevent="togglePayoutApprovedForAll()"
                      :disabled="!globals.isPaymentsEditingAllowed"
                    >
                      <i
                        class="material-icons md-24 text-primary"
                        v-if="generalSettlementData.PayoutApproved === true"
                        >check_box</i
                      >
                      <i
                        class="material-icons md-24"
                        v-else-if="
                          generalSettlementData.PayoutApproved === false
                        "
                        >check_box_outline_blank</i
                      >
                      <i class="material-icons md-24 text-primary" v-else
                        >indeterminate_check_box</i
                      >
                      <span>{{ lang.CPM003 }}</span>
                    </button>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        for="inputBasePaymentAll"
                        class="col-md-3 control-label"
                        >{{ lang.CPM004 }}</label
                      >
                      <div class="col-md-6">
                        <currency-input
                          id="inputBasePaymentAll"
                          class="form-control"
                          v-model="generalSettlementData.BasePayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!generalSettlementData.EnableEditPayments"
                          @change="
                            writeToAllChecks('BasePayment'),
                              calcGeneralTotalPayment()
                          "
                        ></currency-input>
                      </div>
                      <div class="col-md-3 sum-container">
                        <i class="material-icons md-24">functions</i>
                        <span>{{
                          globals.getCurrencyString(
                            generalSettlementData.BasePaymentSum,
                            "EUR"
                          )
                        }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPlusPaymentAll"
                        class="col-md-3 control-label"
                        >{{ lang.CPM005 }}</label
                      >
                      <div class="col-md-6">
                        <currency-input
                          id="inputPlusPaymentAll"
                          class="form-control"
                          v-model="generalSettlementData.PlusPayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!generalSettlementData.EnableEditPayments"
                          @change="
                            writeToAllChecks('PlusPayment'),
                              calcGeneralTotalPayment()
                          "
                        ></currency-input>
                      </div>
                      <div class="col-md-3 sum-container">
                        <i class="material-icons md-24">functions</i>
                        <span>{{
                          globals.getCurrencyString(
                            generalSettlementData.PlusPaymentSum,
                            "EUR"
                          )
                        }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputMinusPaymentAll"
                        class="col-md-3 control-label"
                        >{{ lang.CPM006 }}</label
                      >
                      <div class="col-md-6">
                        <currency-input
                          id="inputMinusPaymentAll"
                          class="form-control"
                          v-model="generalSettlementData.MinusPayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!generalSettlementData.EnableEditPayments"
                          @change="
                            writeToAllChecks('MinusPayment'),
                              calcGeneralTotalPayment()
                          "
                        ></currency-input>
                      </div>
                      <div class="col-md-3 sum-container">
                        <i class="material-icons md-24">functions</i>
                        <span>{{
                          globals.getCurrencyString(
                            generalSettlementData.MinusPaymentSum,
                            "EUR"
                          )
                        }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM007
                      }}</label>
                      <div class="col-md-6">
                        <label
                          class="form-control text-left"
                          :disabled="!generalSettlementData.EnableEditPayments"
                          >{{
                            globals.getCurrencyString(
                              generalSettlementData.TotalPayment,
                              "EUR"
                            )
                          }}</label
                        >
                      </div>
                      <div class="col-md-3 sum-container">
                        <i class="material-icons md-24">functions</i>
                        <span>{{
                          globals.getCurrencyString(
                            generalSettlementData.TotalPaymentSum,
                            "EUR"
                          )
                        }}</span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM008
                      }}</label>
                      <div class="col-md-6">
                        <div style="height: 45px"></div>
                      </div>
                      <div class="col-md-3 sum-container">
                        <i class="material-icons md-24">functions</i>
                        <span>{{
                          globals.getCurrencyString(
                            generalSettlementData.PurchaseMoneySum,
                            "EUR"
                          )
                        }}</span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label
                        for="inputSettlementCommentAll"
                        class="col-md-3 control-label"
                        >{{ lang.CPM009 }}</label
                      >
                      <div class="col-md-9">
                        <textarea
                          class="form-control"
                          rows="4"
                          type="text"
                          id="inputSettlementCommentAll"
                          v-model="generalSettlementData.SettlementComment"
                          :disabled="!generalSettlementData.EnableEditPayments"
                          @change="writeToAllChecks('SettlementComment')"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Accordion entry 2 -->
              <div
                class="panel-heading"
                role="button"
                id="headingCheckPaymentSpecific"
                data-toggle="collapse"
                data-parent="#accordionCheckPayment"
                href="#collapseCheckPaymentSpecific"
                aria-expanded="false"
                aria-controls="collapseCheckPaymentSpecific"
              >
                <h4 class="panel-title">
                  <a class="collapsed">{{ lang.CPM010 }}</a>
                </h4>
              </div>
              <div
                id="collapseCheckPaymentSpecific"
                class="panel-collapse collapse"
                role="tabpanel"
                aria-labelledby="headingCheckPaymentSpecific"
              >
                <div class="panel-body" style="padding: 15px">
                  <div class="col-md-2" id="checkListContainer">
                    <table class="table table-striped table-hover main-table">
                      <thead>
                        <tr>
                          <th class="text-center">{{ lang.CPM011 }}</th>
                        </tr>
                      </thead>
                      <tbody class="main-table-scrollbar" id="check-list-table">
                        <tr
                          role="button"
                          v-for="check in checkDataList"
                          :key="check.SurveyInstanceId"
                          @click="selectedCheck = check"
                          :class="{
                            info:
                              selectedCheck.SurveyInstanceId ===
                              check.SurveyInstanceId,
                          }"
                        >
                          <td>{{ check.SurveyInstanceId }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    class="col-md-10"
                    v-show="selectedCheck.SurveyInstanceId"
                  >
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM012
                      }}</label>
                      <div class="col-md-9">
                        <label class="form-control text-left">{{
                          selectedCheck.ProjectName
                        }}</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM013
                      }}</label>
                      <div class="col-md-9">
                        <label class="form-control text-left">{{
                          selectedCheck.WaveName
                        }}</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM014
                      }}</label>
                      <div class="col-md-9">
                        <label class="form-control text-left">{{
                          selectedCheck.ScenarioName
                        }}</label>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="selectedCheck.ShopperUsername"
                    >
                      <label class="col-md-3 control-label">{{
                        lang.CPM015
                      }}</label>
                      <div class="col-md-9">
                        <label class="form-control text-left">
                          {{ selectedCheck.ShopperFirstName }}
                          {{ selectedCheck.ShopperLastName }} ({{
                            selectedCheck.ShopperUsername
                          }})
                          <span class="pull-right vat-mandatory-info">
                            {{ lang.CPM016 }}:
                            <i
                              v-if="selectedCheck.VatNotMandatory"
                              class="material-icons text-red icon-vat-mandatory"
                              >clear</i
                            >
                            <i
                              v-else
                              class="material-icons text-green icon-vat-mandatory"
                              >done</i
                            >
                          </span>
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <label
                        for="inputBasePayment"
                        class="col-md-3 control-label"
                        >{{ lang.CPM004 }}</label
                      >
                      <div class="col-md-9">
                        <currency-input
                          id="inputBasePayment"
                          class="form-control"
                          v-model="selectedCheck.BasePayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!selectedCheck.EnableEditPayments"
                          @change="calcSpecificTotalPayment()"
                        ></currency-input>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPlusPayment"
                        class="col-md-3 control-label"
                        >{{ lang.CPM005 }}</label
                      >
                      <div class="col-md-9">
                        <currency-input
                          id="inputPlusPayment"
                          class="form-control"
                          v-model="selectedCheck.PlusPayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!selectedCheck.EnableEditPayments"
                          @change="calcSpecificTotalPayment()"
                        ></currency-input>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputMinusPayment"
                        class="col-md-3 control-label"
                        >{{ lang.CPM006 }}</label
                      >
                      <div class="col-md-9">
                        <currency-input
                          id="inputMinusPayment"
                          class="form-control"
                          v-model="selectedCheck.MinusPayment"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!selectedCheck.EnableEditPayments"
                          @change="calcSpecificTotalPayment()"
                        ></currency-input>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM007
                      }}</label>
                      <div class="col-md-9">
                        <label
                          class="form-control text-left"
                          :disabled="!selectedCheck.EnableEditPayments"
                          >{{
                            globals.getCurrencyString(
                              selectedCheck.TotalPayment,
                              "EUR"
                            )
                          }}</label
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputPurchaseMoney"
                        class="col-md-3 control-label"
                        >{{ lang.CPM008 }}</label
                      >
                      <div class="col-md-9">
                        <currency-input
                          id="inputPurchaseMoney"
                          class="form-control"
                          v-model="selectedCheck.PurchaseMoney"
                          currency="EUR"
                          :min="0"
                          :locale="globals.currentLocale"
                          :disabled="!selectedCheck.EnableEditPayments"
                          @change="calcSpecificTotalPayment()"
                        ></currency-input>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM017
                      }}</label>
                      <div class="col-md-9">
                        <label
                          class="form-control text-left"
                          :disabled="!selectedCheck.EnableEditPayments"
                          >{{
                            globals.getCurrencyString(
                              selectedCheck.Payout,
                              "EUR"
                            )
                          }}</label
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputSettlementComment"
                        class="col-md-3 control-label"
                        >{{ lang.CPM009 }}</label
                      >
                      <div class="col-md-9">
                        <textarea
                          class="form-control"
                          rows="4"
                          type="text"
                          id="inputSettlementComment"
                          v-model="selectedCheck.SettlementComment"
                          :disabled="!selectedCheck.EnableEditPayments"
                        ></textarea>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-3 control-label">{{
                        lang.CPM018
                      }}</label>
                      <div class="col-md-9 text-left">
                        <button
                          type="button"
                          class="btn btn-raised btn-default"
                          :disabled="
                            !selectedCheck.EnablePayoutApprovedChange ||
                            !globals.isPaymentsEditingAllowed
                          "
                          @click="
                            selectedCheck.PayoutApproved = !selectedCheck.PayoutApproved
                          "
                        >
                          {{
                            selectedCheck.PayoutApproved
                              ? lang.CPM019
                              : lang.CPM020
                          }}
                        </button>
                        <span v-if="selectedCheck.PayoutApproved">
                          <span v-if="selectedCheck.PayoutApprovedAt"
                            >{{ lang.CPM021 }}:
                            {{
                              globals.getLocalizedDateTimeFromUtcIsoTimestamp(
                                selectedCheck.PayoutApprovedAt
                              )
                            }}</span
                          >
                          <span v-else>{{ lang.CPM022 }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Add modal buttons here -->
          <button
            type="button"
            class="btn btn-raised pull-left edit-vat-btn"
            v-if="globals.isPaymentsEditingAllowed"
            @click="openEditVATModal()"
          >
            {{ lang.CPM025 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.CPM023 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-success"
            :class="{ 'btn-warning': paymentFormDirty }"
            v-if="globals.isPaymentsEditingAllowed"
            @click="savePaymentData()"
          >
            {{ lang.CPM024 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckPaymentModal",
  components: {},
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#checkPaymentModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });

    $("#collapseCheckPaymentSpecific").on("show.bs.collapse", () => {
      $("#checkPaymentModal .modal-dialog").css("width", "1200px");
    });
    $("#collapseCheckPaymentSpecific").on("hide.bs.collapse", () => {
      $("#checkPaymentModal .modal-dialog").css("width", "");
    });
    $("#collapseCheckPaymentGeneral").on("show.bs.collapse", () => {
      this.calcGeneralPaymentData();
    });
  },
  methods: {
    openModal() {
      this.selectedCheck = {};
      this.checkDataList = [];
      this.generalSettlementData = {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0,
      };
      let success = () => {
        $("#checkPaymentModal").modal("show");
      };
      let error = () => {
        this.$emit("modalClosed");
      };
      this.getPaymentData(success, error);
    },
    closeModal() {
      $("#checkPaymentModal").modal("hide");
    },
    openEditVATModal() {
      this.globals.$emit("openEditVatRatesModal");
    },
    getPaymentData(success, error) {
      let query = `api/SurveyInstances/Properties/Settlement`;

      $.ajax({
        method: "POST",
        url: query,
        data: JSON.stringify(this.surveyInstanceGuids),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!data || _.isEmpty(data)) {
            console.error("Unexpected server response in getPaymentData()");
            if (error) error();
            return;
          }
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            if (error) error();
            return;
          }
          this.checkDataList = data;
          this.paymentFormDirty = false;

          if (!this.globals.isPaymentsEditingAllowed)
            for (let check of this.checkDataList) {
              check.EnableEditPayments = false;
            }

          if (!this.selectedCheck.SurveyInstanceGuid)
            this.selectedCheck = this.checkDataList[0];
          else {
            this.selectedCheck = _.find(this.checkDataList, (c) => {
              return (
                c.SurveyInstanceGuid === this.selectedCheck.SurveyInstanceGuid
              );
            });
          }
          this.calcGeneralPaymentData();
          if (success) success();
        },
        error: (err) => {
          console.error("Error on POST in getPaymentData()");
          this.globals.showErrorSnackbar(this.lang.CPM026);
          if (error) error();
        },
      });
    },
    savePaymentData() {
      if (this.hasNegativePayout()) {
        this.globals.showErrorSnackbar(this.lang.CPM030);
        console.error("At least one check has a negative payout value");
        return;
      }

      let query = `api/SurveyInstances/Properties/Settlement`;

      $.ajax({
        method: "PUT",
        url: query,
        data: JSON.stringify(this.checkDataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!data) return;
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.CPM027);
          this.getPaymentData();
        },
        error: (error) => {
          console.error("Error on PUT in savePaymentData()");
          this.globals.showErrorSnackbar(this.lang.CPM028);
        },
      });
    },
    hasNegativePayout() {
      for (let check of this.checkDataList) {
        if (check.Payout < 0) return true;
      }
      return false;
    },
    calcGeneralTotalPayment() {
      this.generalSettlementData.TotalPayment = 0;
      if (this.generalSettlementData.BasePayment)
        this.generalSettlementData.TotalPayment += this.generalSettlementData.BasePayment;
      if (this.generalSettlementData.PlusPayment)
        this.generalSettlementData.TotalPayment += this.generalSettlementData.PlusPayment;
      if (this.generalSettlementData.MinusPayment)
        this.generalSettlementData.TotalPayment -= this.generalSettlementData.MinusPayment;
    },
    calcSpecificTotalPayment(check = this.selectedCheck) {
      check.TotalPayment = 0;
      if (check.BasePayment) check.TotalPayment += check.BasePayment;
      if (check.PlusPayment) check.TotalPayment += check.PlusPayment;
      if (check.MinusPayment) check.TotalPayment -= check.MinusPayment;
      check.Payout = check.TotalPayment;
      if (check.PurchaseMoney) check.Payout += check.PurchaseMoney;
      this.$forceUpdate();
    },
    calcGeneralPaymentData() {
      this.generalSettlementData.BasePaymentSum = 0;
      this.generalSettlementData.PlusPaymentSum = 0;
      this.generalSettlementData.MinusPaymentSum = 0;
      this.generalSettlementData.PurchaseMoneySum = 0;
      this.generalSettlementData.TotalPaymentSum = 0;
      this.generalSettlementData.PayoutApproved = !!this.checkDataList[0]
        .PayoutApproved;
      this.generalSettlementData.EnableEditPayments = true;

      for (let check of this.checkDataList) {
        this.calcSpecificTotalPayment(check);
        if (check.BasePayment)
          this.generalSettlementData.BasePaymentSum += check.BasePayment;
        if (check.PlusPayment)
          this.generalSettlementData.PlusPaymentSum += check.PlusPayment;
        if (check.MinusPayment)
          this.generalSettlementData.MinusPaymentSum += check.MinusPayment;
        if (check.PurchaseMoney)
          this.generalSettlementData.PurchaseMoneySum += check.PurchaseMoney;
        if (check.TotalPayment)
          this.generalSettlementData.TotalPaymentSum += check.TotalPayment;

        if (check.PayoutApproved !== this.generalSettlementData.PayoutApproved)
          this.generalSettlementData.PayoutApproved = "mixed";

        this.generalSettlementData.EnableEditPayments =
          this.generalSettlementData.EnableEditPayments &&
          !!check.EnableEditPayments;
      }
    },
    writeToAllChecks(prop) {
      for (let check of this.checkDataList) {
        check[prop] = this.generalSettlementData[prop];
      }
      this.calcGeneralPaymentData();
    },
    togglePayoutApprovedForAll() {
      let idx = _.findIndex(this.checkDataList, (c) => {
        return !c.EnablePayoutApprovedChange;
      });
      if (idx > -1) {
        this.globals.showErrorSnackbar(this.lang.CPM029);
        console.error(
          "At least one check is not allowed to change payout approval state"
        );
        return;
      }
      this.generalSettlementData.PayoutApproved = !this.generalSettlementData
        .PayoutApproved;
      this.writeToAllChecks("PayoutApproved");
      this.$forceUpdate();
    },
    showDialogData() {
      this.generalSettlementData.BasePayment = this.showNumberData(
        this.generalSettlementData.BasePayment
      );
      this.generalSettlementData.PlusPayment = this.showNumberData(
        this.generalSettlementData.PlusPayment
      );
      this.generalSettlementData.MinusPayment = this.showNumberData(
        this.generalSettlementData.MinusPayment
      );
      this.generalSettlementData.TotalPayment = this.showNumberData(
        this.generalSettlementData.TotalPayment
      );
    },
    showNumberData(field) {
      return field ? (field !== -1 ? field : null) : 0;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) this.openModal();
      else this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: ["surveyInstanceGuids", "showModal"],
  data() {
    return {
      checkDataList: [],
      selectedCheck: {},
      paymentFormDirty: false,
      generalSettlementData: {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0,
      },
      lang: {
        CPM000: "Payments",
        CPM001: "All Checks",
        CPM002:
          "ATTENTION: Changing these values will update all selected checks!",
        CPM003: "Invoice release",
        CPM004: "Payment",
        CPM005: "Addition",
        CPM006: "Deduction",
        CPM007: "Total",
        CPM008: "Others",
        CPM009: "Comment",
        CPM010: "Individual Processing",
        CPM011: "Checks",
        CPM012: "Project",
        CPM013: "Wave",
        CPM014: "Scenario",
        CPM015: "Shopper",
        CPM016: "VAT Mandatory",
        CPM017: "Payout",
        CPM018: "Invoice",
        CPM019: "Remove release",
        CPM020: "Release invoice",
        CPM021: "Release submitted at",
        CPM022: "Release will be submitted after saving.",
        CPM023: "Close",
        CPM024: "Save",
        CPM025: "Tax rates",
        CPM026: "Payment data access failed",
        CPM027: "Payment data updated",
        CPM028: "Payment data update failed",
        CPM029:
          "At least one check is not allowed to change payout approval state",
        CPM030: "Negative payout",
      },
    };
  },
};
</script>

<style scoped>
#checkPaymentModal .modal-dialog {
  transition: all 200ms ease;
}

#collapseCheckPaymentSpecific {
  max-height: calc(100vh - 300px);
  overflow: auto;
}

#checkPaymentModal .modal-footer > button.edit-vat-btn {
  margin-left: 5px;
}

#accordionCheckPayment {
  margin: 0;
}

.main-table-scrollbar {
  height: calc(100vh - 370px);
}

#checkListContainer td,
#checkListContainer th {
  width: 100%;
}

.form-group > label,
.form-group > div {
  padding: 0;
}

.sum-container {
  top: 8px;
}
.sum-container .material-icons {
  position: absolute;
  left: 20px;
}

.vat-mandatory-info {
  position: relative;
  top: -6px;
}
.icon-vat-mandatory {
  position: relative;
  top: 6px;
}

.form-group label.form-control[disabled] {
  background-color: rgb(240, 240, 240);
  color: #555;
}
</style>



// WEBPACK FOOTER //
// CheckPaymentModal.vue?18628821